import { HttpClient } from './service'

export interface BudgetExternalPosition {
  id?: number
  position_name: string  // Standardized field name
  supplier_name?: string | null  // Standardized (was: supplier)
  unit: number
  unit_name?: string
  price_per_unit: number | string  // Standardized (was: unit_price)
  description?: string | null  // Optional description for this position
  created_at?: string
  updated_at?: string
}

export interface BudgetUnit {
  id: number
  name: string
  relationship: string
  factor?: number | null
  is_read_only: boolean
  created_at: string
  updated_at: string
}

class BudgetExternalCostsApi {
  private basePath = '/api/budget-module/settings'

  // External Positions
  async getExternalPositions(): Promise<BudgetExternalPosition[]> {
    return HttpClient.get<BudgetExternalPosition[], null>(`${this.basePath}/external-positions/`)
  }

  async createExternalPosition(data: BudgetExternalPosition): Promise<BudgetExternalPosition> {
    return HttpClient.post<BudgetExternalPosition, BudgetExternalPosition>(`${this.basePath}/external-positions/`, data)
  }

  async updateExternalPosition(id: number, data: Partial<BudgetExternalPosition>): Promise<BudgetExternalPosition> {
    return HttpClient.patch<BudgetExternalPosition, Partial<BudgetExternalPosition>>(`${this.basePath}/external-positions/`, id, data)
  }

  async deleteExternalPosition(id: number): Promise<void> {
    return HttpClient.delete<void, void>(`${this.basePath}/external-positions/`, id)
  }

  async bulkCreateExternalPositions(data: BudgetExternalPosition[]): Promise<BudgetExternalPosition[]> {
    return HttpClient.post<BudgetExternalPosition[], BudgetExternalPosition[]>(`${this.basePath}/external-positions/`, data)
  }

  async bulkUpdateExternalPositions(data: BudgetExternalPosition[]): Promise<BudgetExternalPosition[]> {
    return HttpClient.post<BudgetExternalPosition[], BudgetExternalPosition[]>(`${this.basePath}/external-positions/bulk_update/`, data)
  }

  async bulkDeleteExternalPositions(ids: number[]): Promise<void> {
    return HttpClient.post<void, { ids: number[] }>(`${this.basePath}/external-positions/bulk_delete/`, { ids })
  }

  // Units
  async getUnits(): Promise<BudgetUnit[]> {
    return HttpClient.get<BudgetUnit[], null>(`${this.basePath}/units/`)
  }
}

export default new BudgetExternalCostsApi()